import React, {useEffect} from 'react';
import $ from "jquery";

function ProjectleaderNewModalTable(props) {

    useEffect(() => {
        //initialize datatable
        $('#newProjectleaderTable').DataTable({
            dom: 'frtilp', language: {
                fontcolor: 'white', url: 'https://cdn.datatables.net/plug-ins/1.10.24/i18n/German.json' // German Language - DataTable Plugin
            }, oLanguage: {
                sSearch: '', searchPlaceholder: 'Suchen'
            }, "paging": true, "pageLength": 5
        });
    }, []);


    function addLeader(user) {
        if (props.projectLeadDetails.find(item => (item.firstName === user.fn &&
        item.lastName===user.ln && item.email===user.em)) === undefined) {
        let newPL = {
            anrede:user.gn,
            firstName: user.fn,
            lastName: user.ln,
            email: user.em,
            telefon: user.co,
            input_rank:user.uid
    }
            let pleaderlist = props.projectLeadDetails
            pleaderlist.push(newPL)
            props.setProjectLeadDetails(pleaderlist)
            props.setShow(false)
        }else{
            alert("Es ist schon da!")
        }
    }


    function getNewprojectleadersTableBody(newpldata) {
        let result = newpldata
        // .filter(md =>
         //    props.geraeteDataInfo.every(fd => (fd.name !== md.title)))
        return result?.map((item) => (<tr key={item.user_id}
                                          onClick={() =>
                                              addLeader(item)
                                          }>
            <td>{item.fn}</td>
            <td>{item.ln}</td>
        </tr>));
    }

    return (<div>
            <table id="newDevicesTable" className="table handwai-white-text">
                <thead>
                <tr>
                <th>Vorname</th>
                <th>Nachname</th>
                </tr>
                </thead>
                <tbody>{getNewprojectleadersTableBody(props.newProjectLeaders)}</tbody>
            </table>
        </div>);
}

export default ProjectleaderNewModalTable;
